export class TrainingBlock {
  id?: number;
  url: string;
  ordering?: number;
  status: TrainingBlockStatus;
  dirty?: boolean;
  createdAt?: Date;
}

export enum TrainingBlockStatus {
  Released = 'released',
  Deleted = 'deleted',
}
